import Vue from 'vue'
import VueRouter from 'vue-router'


import {system} from './admin';
import {user} from './user';

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {path: '/', redirect: 'index'},
  ...user,
  ...system


];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
